<template>
  <transition name="fade">
    <div
      v-if="show"
      class="map-notice map-notice--top zoom-pulse"
    >
      <div class="map-notice__content">
        <theme-icon icon="info-icon" type="icons" class="map-notice__icon" />
        <span class="map-notice__text">For best transit line visibility, switch to light mode</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TransitNotice',
  
  props: {
    /**
     * Whether to show the transit notice
     */
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>
